import BonusLoyalty from "../../components/BonusLoyalty/Index";
import NavSettings from "../../components/common/NavSettings";

const BonosRegalias = () => {
  return (
    <>
      <NavSettings title="Regalías" route="Inicio" active="Regalías" />

      <BonusLoyalty />
    </>
  );
};

export default BonosRegalias;
